<!--===============================
=            CAROUSELS            =
================================-->

<template>
  <!-- carousels -->
  <div>
   
      <v-row>
        <base-header>
          <div slot="page-header">Carousels</div>
        </base-header>
      </v-row>



      <v-row>
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">Custom delimiters</div>
            <div slot="card-subheader">Use any available icon as your carousel’s slide delimiter.</div>
            <div slot="card-body">

              <v-card elevation="0" class="mx-auto rounded-lg ml-5 ma-3">
                <v-system-bar lights-out></v-system-bar>
                <v-carousel :continuous="false" :cycle="cycle" :show-arrows="false" hide-delimiter-background
                            delimiter-icon="mdi-minus" height="200">
                  <v-carousel-item v-for="(slide, i) in slides" :key="i">
                    <v-sheet :color="colors[i]" height="100%" tile>
                      <v-row class="fill-height" align="center" justify="center">
                        <div class="text-h2 white--text">
                          {{ slide }} Slide
                        </div>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-img src="../../assets/images/2.png"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>John Leider</v-list-item-title>
                      <v-list-item-subtitle>Author</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-switch v-model="cycle" label="Cycle Slides" inset></v-switch>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
          </base-card>
        </v-col>
       
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">Customized arrows
            </div>
            <div slot="card-subheader">Arrows can be customized by using prev and next slots.

            </div>
            <div slot="card-body">

              <v-carousel cycle height="320" hide-delimiter-background show-arrows-on-hover>
                <template v-slot:prev="{ on, attrs }">
                  <v-btn color="success" dark v-bind="attrs" v-on="on">Previous slide</v-btn>
                </template>
                <template v-slot:next="{ on, attrs }">
                  <v-btn color="info" v-bind="attrs" v-on="on">Next slide</v-btn>
                </template>
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="colors[i]" height="100%">
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="text-h2 white--text" dark>
                        {{ slide }} Slide
                      </div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>

            </div>
          </base-card>
        </v-col>      <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">Cycle</div>
            <div slot="card-subheader">With the cycle prop you can have your slides automatically transition to the next available every 6s (default).</div>
            <div slot="card-body">

              <v-carousel cycle height="300" hide-delimiter-background show-arrows-on-hover>
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="colors[i]" height="100%">
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="text-h2 white--text">
                        {{ slide }} Slide
                      </div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>

            </div>
          </base-card>
        </v-col>
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">Model</div>
            <div slot="card-subheader">You can control carousel with model.</div>
            <div slot="card-body">

              <div>
                <v-row justify="space-around">
                  <v-icon @click="model--">
                    mdi-minus
                  </v-icon>
                  {{ model }}
                  <v-icon @click="model++">
                    mdi-plus
                  </v-icon>
                </v-row>
                <v-carousel height="300" v-model="model">
                  <v-carousel-item v-for="(color, i) in colors" :key="color">
                    <v-sheet :color="color" height="100%" tile>
                      <v-row class="fill-height" align="center" justify="center" dark>
                        <div class="text-h2 white--text">
                          Slide {{ i + 1 }}
                        </div>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel>
              </div>

            </div>
          </base-card>
        </v-col>

      </v-row>
    
  </div>
</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from "../../components/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        colors: [
          'primary',
          'secondary',
          'yellow darken-4',
          'red lighten-2',
          'orange darken-1',
        ],model:0,
        cycle: false,
        slides: [
          'primary',
          'Second',
          'Third',
          'Fourth',
          'Fifth',
        ],
        items: [{
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
       
      }
    },
    methods: {
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      }
    }
  };
</script>
<style>

</style>

<!--====  End of CAROUSELS  ====-->